var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5458_12151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0032 19.054H3.09402C2.43902 19.054 1.82344 18.9155 1.27616 18.5365C-0.0300069 17.6343 -0.385887 15.9396 0.450908 14.5622C1.3406 13.0974 2.23896 11.6383 3.13346 10.1772C4.91093 7.2757 6.68807 4.37353 8.4649 1.47072C9.02949 0.54736 9.84609 0.0279701 10.9282 0.00103882C12.0506 -0.0258925 12.9201 0.471375 13.5087 1.4284C14.9028 3.69255 16.2913 5.95927 17.6744 8.22856C18.9671 10.3375 20.2586 12.4475 21.5487 14.5584C22.474 16.08 21.9238 17.9854 20.357 18.752C19.8975 18.9641 19.3952 19.0674 18.8892 19.054H11.0032ZM11.7861 9.34524C11.7861 8.5854 11.7861 7.82459 11.7861 7.06474C11.7861 6.59536 11.4427 6.24045 11.0013 6.24045C10.5598 6.24045 10.2193 6.59152 10.2183 7.0657C10.2183 8.5777 10.2183 10.09 10.2183 11.6027C10.2183 12.073 10.554 12.4356 10.9878 12.4443C11.4216 12.4529 11.7823 12.0845 11.7832 11.6017C11.7871 10.8486 11.7861 10.0974 11.7861 9.34524ZM12.0496 14.215C12.0498 14.0069 11.9881 13.8035 11.8724 13.6306C11.7567 13.4576 11.5922 13.323 11.3998 13.2438C11.2074 13.1646 10.9958 13.1443 10.7919 13.1856C10.5879 13.227 10.4009 13.328 10.2545 13.4759C10.1081 13.6237 10.009 13.8118 9.96977 14.0161C9.93052 14.2205 9.9529 14.4319 10.0341 14.6235C10.1152 14.815 10.2515 14.9782 10.4256 15.0921C10.5997 15.2061 10.8038 15.2657 11.0118 15.2634C11.2873 15.2582 11.5498 15.1457 11.7436 14.9499C11.9374 14.7541 12.0472 14.4905 12.0496 14.215Z",
    fill: "#8D82B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5458_12151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 19.0549,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.d8b80361aa322f29465f04319446b906.svg";
export { ForwardRef as ReactComponent };